import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import { baseUrl } from "../../utils/base_url";
import { Link } from "react-router-dom";

const BlogCard = ({ item, index }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <div key={index} className="col-md-6 col-lg-4 pb-5 pb-md-0">
      <Link to={`/blogs/${item?.slug}`} style={{ textDecoration: "none" }}>
        <div
          style={{
            width: "100%",
            borderRadius: "20px",
            overflow: "hidden",
            height: _576?"70%":_1600?"240px":"300px",
          }}
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src={`${baseUrl}${item?.thumbnail?.url}`}
          />
        </div>
        <h1
          style={{
            color: "white",
            fontSize: _576
              ? "20px"
              : _768
              ? "23px"
              : _992
              ? "16px"
              : _1200
              ? "16px"
              : _1400
              ? "16px"
              : _1500
              ? "18px"
              : _1600
              ? "20px"
              : _1700
              ? "20px"
              : _1800
              ? "23px"
              : "25px",
            fontWeight: "800",
            margin: _1400 ? "1rem 0rem" : "2rem 0rem",
            lineHeight: "110.00000000000001%",
          }}
        >
          {item?.heading}
        </h1>
        <p
          style={{
            color: "white",
            fontSize: _576
              ? "15px"
              : _768
              ? "18px"
              : _992
              ? "14px"
              : _1200
              ? "15px"
              : _1400
              ? "15px"
              : _1500
              ? "16px"
              : _1600
              ? "17px"
              : _1700
              ? "18px"
              : _1800
              ? "22px"
              : "22px",
            fontWeight: "500",
            lineHeight: "110.00000000000001%",
          }}
        >
          {item?.excerpt} ...
        </p>
      </Link>
    </div>
  );
};

export const BlogCardWithoutCol = ({ item, index }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <div key={index}>
      <Link to={`/blogs/${item?.slug}`} style={{ textDecoration: "none" }}>
        <div
          style={{
            width: "100%",
            borderRadius: "20px",
            overflow: "hidden",
            height: "250px",
          }}
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src={`${baseUrl}${item?.thumbnail?.url}`}
          />
        </div>
        <h1
          style={{
            color: "white",
            fontSize: _576
              ? "20px"
              : _768
              ? "23px"
              : _992
              ? "16px"
              : _1200
              ? "16px"
              : _1400
              ? "16px"
              : _1500
              ? "18px"
              : _1600
              ? "20px"
              : _1700
              ? "20px"
              : _1800
              ? "23px"
              : "25px",
            fontWeight: "800",
            margin: _1400 ? "1rem 0rem" : "2rem 0rem",
            lineHeight: "110.00000000000001%",
          }}
        >
          {item?.heading}
        </h1>
        <p
          style={{
            color: "white",
            fontSize: _576
              ? "15px"
              : _768
              ? "18px"
              : _992
              ? "14px"
              : _1200
              ? "15px"
              : _1400
              ? "15px"
              : _1500
              ? "16px"
              : _1600
              ? "17px"
              : _1700
              ? "18px"
              : _1800
              ? "22px"
              : "22px",
            fontWeight: "500",
            lineHeight: "110.00000000000001%",
          }}
        >
          {item?.excerpt} ...
        </p>
      </Link>
    </div>
  );
};
export default BlogCard;
